import PropTypes from 'prop-types';
import * as React from 'react';
import { animated, useTransition } from 'react-spring';
import { DialogOverlay, DialogContent } from '@reach/dialog';

import { SearchBar } from './search/search-bar';

function SearchModal({ isSearchModalOpen, setIsSearchModalOpen }) {
  const closeModal = () => setIsSearchModalOpen(false);

  const AnimatedDialogOverlay = animated(DialogOverlay);
  const AnimatedDialogContent = animated(DialogContent);

  const transitions = useTransition(isSearchModalOpen, null, {
    from: { opacity: 0, y: -1 },
    enter: { opacity: 1, y: 0 },
    leave: { opacity: 0, y: -1 },
  });

  return transitions.map(
    ({ item, key, props: styles }) =>
      item && (
        <AnimatedDialogOverlay
          key={key}
          onDismiss={closeModal}
          style={{ opacity: styles.opacity }}
          className="fixed inset-x-0 top-0 z-50 flex w-full h-full min-h-screen overflow-auto backdrop-blur"
        >
          <AnimatedDialogContent
            aria-label="Search"
            style={{
              transform: styles.y.interpolate(
                (value) => `translate3d(0, ${value}rem, 0)`
              ),
            }}
            className="fixed inset-x-0 top-0 flex items-center justify-center w-full h-24 px-4 py-2 m-0 mx-auto bg-white shadow outline-none sm:py-0 sm:h-16 sm:px-6 lg:px-8"
          >
            <div className="flex items-center w-full max-w-3xl mx-auto">
              <SearchBar />
              <button
                type="button"
                onClick={closeModal}
                className="flex items-center justify-center w-8 h-8 ml-4 text-2xl rounded focus:outline-none focus:bg-gray-100"
              >
                <svg
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  className="w-5 h-5 text-gray-500"
                >
                  <path d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </AnimatedDialogContent>
        </AnimatedDialogOverlay>
      )
  );
}

SearchModal.propTypes = {
  isSearchModalOpen: PropTypes.bool.isRequired,
  setIsSearchModalOpen: PropTypes.func.isRequired,
};

export { SearchModal };
